import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastService } from 'ng-uikit-pro-standard';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { CabeceraComponent } from './cabecera/cabecera.component';
import { DetallesComponent } from './detalles/detalles.component';

@Component({
  selector: 'app-cheques-redeposito',
  templateUrl: './cheques-redeposito.component.html',
  styleUrls: ['./cheques-redeposito.component.scss'],
  providers: [SecurityService]
})
export class ChequesRedepositoComponent implements OnInit {

// Modales
  @ViewChild(CabeceraComponent, { static: true }) cabeceraComponent: CabeceraComponent
  @ViewChild(DetallesComponent, { static: true }) detallesComponent: DetallesComponent

  // Data &  Tmp
  private rutEmpresa: number
  private sucursalEmpresa: number

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private toastrService: ToastService
  ) {
    this.log = this.clog.log('PROTESTO-CHEQUES')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())
  }

  onSearch(values) {
    this.detallesComponent.loadData(values)
  }

  onSearchAll() {
    this.detallesComponent.loadAllData()
  }

}
